import type { ParsedJob } from './types';

const TECH_KEYWORDS = [
  'react', 'next.js', 'nextjs', 'node', 'node.js', 'typescript', 'javascript',
  'php', 'python', 'java', 'aws', 'docker', 'kubernetes', 'mysql', 'postgresql',
  'mongodb', 'graphql', 'rest', 'api', 'saas', 'erp', 'crm', 'ci/cd', 'devops',
  'playwright', 'automation', 'quickbooks', 'twilio', 'openai', 'ai', 'ml',
  'full-stack', 'fullstack', 'backend', 'frontend', 'cloud', 'microservices',
  'tailwind', 'express', 'nestjs', 'laravel', 'wordpress', 'android', 'mobile',
  'integration', 'oauth', 'security', 'agile', 'scrum', 'terraform', 'linux',
];

const ROLE_PATTERNS = [
  /(?:hiring|seeking|looking for)[:\s]+(?:a\s+)?([^\n.]{5,80})/i,
  /(?:position|role|title)[:\s]+([^\n.]{5,80})/i,
  /^([A-Z][^\n]{8,70}(?:Engineer|Developer|Architect|Lead|Manager))/m,
];

const COMPANY_PATTERNS = [
  /(?:at|@|join)\s+([A-Z][A-Za-z0-9&.\s]{2,40})(?:\s+is|\s+are|\s+—|\s+-|,|\n|$)/,
  /(?:company|organization)[:\s]+([^\n.]{2,50})/i,
];

export function parseJobDescription(text: string): ParsedJob {
  const normalized = text.replace(/\s+/g, ' ').trim();
  const lower = normalized.toLowerCase();

  const keywords = TECH_KEYWORDS.filter((kw) => {
    const pattern = kw.replace('.', '\\.');
    return new RegExp(`\\b${pattern}\\b`, 'i').test(lower);
  });

  const extraKeywords = extractCapitalizedPhrases(normalized).slice(0, 8);
  const uniqueKeywords = Array.from(new Set([...keywords, ...extraKeywords]));

  let inferredRole: string | undefined;
  for (const pattern of ROLE_PATTERNS) {
    const match = text.match(pattern);
    if (match?.[1]) {
      inferredRole = cleanExtracted(match[1]);
      break;
    }
  }

  let inferredCompany: string | undefined;
  for (const pattern of COMPANY_PATTERNS) {
    const match = text.match(pattern);
    if (match?.[1]) {
      inferredCompany = cleanExtracted(match[1]);
      break;
    }
  }

  return { keywords: uniqueKeywords, inferredCompany, inferredRole };
}

function extractCapitalizedPhrases(text: string): string[] {
  const matches = text.match(/\b[A-Z][a-z]+(?:\s+[A-Z][a-z]+){0,2}\b/g) || [];
  const stop = new Set(['The', 'You', 'We', 'Our', 'Your', 'This', 'That', 'With', 'About']);
  return matches.filter((m) => !stop.has(m) && m.length > 3);
}

function cleanExtracted(value: string): string {
  return value.replace(/\s+/g, ' ').replace(/[|•]/g, '').trim().slice(0, 80);
}
